export const getPrice = (
  duration: 15 | 30 | 45 | 60,
  type: "human" | "stripe" = "human"
) => {
  switch (duration) {
    case 15:
      return type === "stripe" ? 300_00 : 300;
    case 30:
      return type === "stripe" ? 600_00 : 600;
    case 45:
      return type === "stripe" ? 750_00 : 750;
    case 60:
      return type === "stripe" ? 900_00 : 900;
  }
};

export const getEventTypeId = (
  purpose: "health" | "government" | "school" | "other"
) => {
  switch (purpose) {
    case "health":
      return 698362;
    case "government":
      return 698366;
    case "school":
      return 698367;
    case "other":
      return 698368;
  }
};
